<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="状态">
                  <el-input  v-model="queryForm.status"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopPlatformWithdrawList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
          <el-button
              type="primary"
              size="small"
              @click="openDialog"
            >提现</el-button>
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopPlatformWithdraw"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopPlatformWithdraw(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopPlatformWithdraw(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopPlatformWithdrawList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopPlatformWithdrawList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopPlatformWithdrawList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderNumber"
        label="订单编号"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money"
        label="提现金额"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="状态"
      >
          <template scope="scope">
              <div v-if="scope.row.status == 1" class="active" style="display: flex;justify-content: center">
                  <span style="font-size: 25px;margin-top: -2px">●</span>
                  <span>提现成功</span>
              </div>
              <div v-else style="display: flex;justify-content: center">
                  <span style="font-size: 25px;margin-top: -2px">●</span>
                  <span>提现失败</span>
              </div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="info"
        label="成功或失败原因"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
<!--      <el-table-column-->
<!--        fixed="right"-->
<!--        align="center"-->
<!--        label="操作"-->
<!--        width="300"-->
<!--      >-->
<!--        <template slot-scope="scop">-->
<!--          <div class="operation">-->
<!--            <div @click="checkShopPlatformWithdraw(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editShopPlatformWithdraw(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteShopPlatformWithdraw(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopPlatformWithdrawStates[shopPlatformWithdrawState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopPlatformWithdraw"
          ref="shopPlatformWithdrawForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="提现金额"
            prop="money"
          >
            <el-input
              size="small"
              v-model="shopPlatformWithdraw.money"
              :disabled="shopPlatformWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="状态"
            prop="status"
          >
            <el-input
              size="small"
              v-model="shopPlatformWithdraw.status"
              :disabled="shopPlatformWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="成功或失败原因"
            prop="info"
          >
            <el-input
              size="small"
              v-model="shopPlatformWithdraw.info"
              :disabled="shopPlatformWithdrawState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopPlatformWithdrawState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

      <!-- 提现 -->
      <el-dialog
          title="提现"
          :visible.sync="addWithDraw"
          width="400px"
          @close="closeAddDialog"
      >
          <div>
              <el-form
                  :model="shopPlatformWithdraw"
                  ref="shopAddWithdraw"
                  :rules="rules"
                  label-width="80px"
                  :inline="true"
                  size="small"
              >
                  <el-form-item
                      style="width: 100%;"
                      label="提现金额"
                      prop="money"
                  >
                      <el-input
                          style="width: 290px;"
                          size="small"
                          v-model="shopPlatformWithdraw.money"
                      ></el-input>
                  </el-form-item>
              </el-form>
          </div>

          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeAddDialog">关闭</el-button>
              <el-button
                  type="primary"
                  @click="submitAddForm"
              >确定</el-button>
          </div>
      </el-dialog>

  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopPlatformWithdrawList();
                    this.getShopPlatformWithdrawList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopPlatformWithdrawList();
                    this.getShopPlatformWithdrawList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     money: '', //提现金额
                     status: '', //状态
                     info: '', //成功或失败原因
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopPlatformWithdrawState: 'add',
                shopPlatformWithdrawStates: {
                    add: '新建提现',
                    check: '查看提现',
                    edit: '修改提现'
                },

                multipleSelection: [],
                shopPlatformWithdrawList: [],
                shopPlatformWithdraw: {
                    id: '', //ID
                    money: '', //提现金额
                    status: '', //状态
                    info: '', //成功或失败原因
                },
                btnLoading: false,
                addWithDraw: false,
                rules: {
                    money: [{ required: true, message: '提现金额不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
                    info: [{ required: true, message: '成功或失败原因不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getShopPlatformWithdrawList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            openDialog(){
                this.addWithDraw = true;
            },
            closeAddDialog(){
                this.shopPlatformWithdraw.money = "";
                this.addWithDraw = false;
            },
            submitAddForm(){
                this.$refs.shopAddWithdraw.validate((valid) => {
                    if (valid) {
                        post('/shop/platformwithdraw/withdraw',{
                            money: this.shopPlatformWithdraw.money
                        }).then((res)=>{
                            if(res.success){
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopPlatformWithdrawList()
                                this.getShopPlatformWithdrawList();
                                this.closeAddDialog()
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        })
                    }
                });
            },
            resetShopPlatformWithdrawList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopPlatformWithdrawList = [];
            },
            resetDialog() {
                this.shopPlatformWithdrawState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      money: '', //提现金额
                      status: '', //状态
                      info: '', //成功或失败原因
                };
                this.getShopPlatformWithdrawList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopPlatformWithdraw = {
                      id: '', //ID
                      money: '', //提现金额
                      status: '', //状态
                      info: '', //成功或失败原因
                };
            },
            submitForm() {
                if (this.shopPlatformWithdrawState == 'add') {
                    this.$refs.shopPlatformWithdrawForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/platformwithdraw/add`,{ ...this.shopPlatformWithdraw }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopPlatformWithdrawList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopPlatformWithdrawState == 'edit') {
                    this.$refs.shopPlatformWithdrawForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/platformwithdraw/edit`,{ ...this.shopPlatformWithdraw }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopPlatformWithdrawList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopPlatformWithdraw() {
                this.showDialog = true;
                this.shopPlatformWithdrawState = 'add';
            },
            checkShopPlatformWithdraw(shopPlatformWithdrawId) {
                console.log(shopPlatformWithdrawId);
                this.currentShopPlatformWithdrawId = shopPlatformWithdrawId;

                this.getShopPlatformWithdrawById();
                this.showDialog = true;
                this.shopPlatformWithdrawState = 'check';
            },
            editShopPlatformWithdraw(shopPlatformWithdrawId) {
                console.log('shopPlatformWithdraw', shopPlatformWithdrawId);
                if (shopPlatformWithdrawId) {
                    this.currentShopPlatformWithdrawId = shopPlatformWithdrawId;
                    this.getShopPlatformWithdrawById();
                } else {
                    this.shopPlatformWithdraw = { ...this.shopPlatformWithdraw, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopPlatformWithdrawState = 'edit';
            },
            deleteShopPlatformWithdraw(shopPlatformWithdrawId) {
                let ids = '';
                if (shopPlatformWithdrawId) {
                    ids = shopPlatformWithdrawId;
                } else {
                    ids = this.multipleSelection.map((shopPlatformWithdraw) => shopPlatformWithdraw.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/platformwithdraw/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopPlatformWithdrawList();
                                this.getShopPlatformWithdrawList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopPlatformWithdrawList() {
                this.resetShopPlatformWithdrawList();
                this.getShopPlatformWithdrawList();
            },
            getShopPlatformWithdrawList(query = {}) {
                this.loading = true;
                get(`/shop/platformwithdraw/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopPlatformWithdrawList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopPlatformWithdrawById() {
                get(`/shop/platformwithdraw/get`,{ id: this.currentShopPlatformWithdrawId }).then((res) =>{
                    if(res.success){
                      this.shopPlatformWithdraw = { ...this.shopPlatformWithdraw, ...res.shopPlatformWithdraw };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopPlatformWithdrawList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/platformwithdraw/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/platformwithdraw/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/platformwithdraw/importData`,formData);
              this.refreshShopPlatformWithdrawList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopPlatformWithdrawList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopPlatformWithdrawList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.active{
    color:#67C23A;
}
</style>